<template>
    <div class="main-box mh-a softwarePage">
        <!-- <iristar-dividing>{{ $t("software.title") }}</iristar-dividing> -->
        <div class="h140px ovh lh140 fs30 c-white text-center solution-title"
            :style="`background-image: url(/static/img/solution/s2.jpg);`">
            {{ $t("software.title") }}
        </div>
        <div class="p30  detailContent" style="" v-for="(item, index) in software" :key="`${index}_software`">
            <p :id="item.id" style="height: 0;position: relative;top: -60px;"></p>
            <div class="software-title text-center fs32" style="padding-bottom: 20px; font-size: 24px;">
                {{ item.title }}
            </div>
            <div class="software-subtitle">
                {{
                item.desc }}</div>

            <div v-for="(soft, dx) in item.introduce" :key="`${dx}_intr`" :class="soft.class"
                style="margin-top:15px ;margin-bottom: 3em;" class="soft-item">
                <div class="detail-img">
                    <img :src="'/static/img/programme/' + item.img[dx]" alt="">
                </div>
                <div style="flex:1" class="softdetail">
                    <p class=" lh30 fs14  soft-text" :class="soft.class + dx" v-if="soft.type === 'html'"
                        v-html="soft.inner">
                    </p>
                    <p class=" lh30 ext-indent  text-indent fs14  soft-text" v-else-if="soft.type === 'subtitle'"
                        v-html="soft.inner">
                    </p>

                    <p class="text-indent lh30 fs14  soft-text" v-else-if="soft.type === 'text'">{{ soft.inner }}</p>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
// import IristarDividing from "@/components/IristarDividing";
import SoftwareList from "@/assets/software/software";
import SoftwareListEn from "@/assets/software/software-en";
export default {
    // components: { IristarDividing },
    name: "IristarSoftware",
    computed: {
        software() {
            return this.$store.state.language === "zh"
                ? SoftwareList
                : SoftwareListEn;
        },
    },
    watch: {
        '$route.query.anchor'(anchorval) {
            var anchor = document.getElementById(anchorval);
            anchor.scrollIntoView({
                // behavior: "smooth",  // 平滑过渡
                block: "start"  // 上边框与视窗顶部平齐。默认值
            });




        }
    },
    mounted() {
        if (this.$route.query && this.$route.query.anchor) {
            var anchor = document.getElementById(this.$route.query.anchor);
            this.$nextTick(() => {
                setTimeout(() => {
                    anchor.scrollIntoView({
                        // behavior: "smooth",  // 平滑过渡
                        block: "start"  // 上边框与视窗顶部平齐。默认值
                    });
                }, 600)
            })

        }
    }
};
</script>

<style lang="less">
.software-title {
    // border-left: 5px solid rgba(#14284b, 0.8);
    // text-indent: 8px;
    font-size: 20px;
    font-weight: 600;

    margin-bottom: 12px;
}



.software-subtitle {

    line-height: 230%;
    font-size: 18px;
    text-indent: 2em;
    margin-bottom: 26px;

    margin: 15px 0;
}

.softwarePage .detail-img {
    // width: 90%;
    padding: 10px;
    text-align: center;
}

.softwarePage .soft-item {
    padding: 0 20px;

}

.softwarePage .softdetail {
    width: 100%;
    // flex: none;
}

.softdetail p {
    font-size: 15px;
    margin-bottom: 0.6em;
}

@media (min-width: 768px) {
    .software-subtitle {
        padding-right: 220px;
        padding-left: 30px;
        font-size: 16px;
    }

    .softwarePage .soft-item {
        padding: 0 60px;
        display: flex;
    }

    .softwarePage .detail-img {
        width: 400px;
        padding: 30px 50px;
    }

    .softdetail .soft-text {
        padding-right: 220px;
    }

    .softdetail p {
        font-size: 16px;
        margin-bottom: 1em;
    }

}



.detailContent p {
    // line-height: 300%;
}



.detailContent .tit {
    font-size: 18px;
    margin-bottom: 0;
    font-weight: 600;
}

.d-a2 .soft-text {
    padding-top: 30px;
}

.d-c10 {
    margin-top: 40px;
}

.d-c21 {
    margin-top: 40px;
}

.d-d10 {
    margin-top: 30px;
}

.d-e10 {
    margin-top: 40px;
}

.d-e2 {
    margin-top: 40px;
}

.d-e21 {
    margin-top: 40px;
}

.d-e32 {
    margin-top: 40px;
}
</style>